import styled from "styled-components/macro";
import InputMask from "react-input-mask";
import ReactDatePicker from "react-datepicker";
import { rgba } from "polished";

import {
  breakpoint,
  space,
  colors,
  boxShadow,
  borderRadius,
  fontStyle,
  zIndex,
} from "shared/styles/constants";
import { Spacer } from "shared/layout";
import { IFormFieldStyle } from "shared/types";
import { Icon } from "shared/styles/Icon";

import { InputFieldStyles } from "../styles";

export interface SimpleDateTimeFieldContainerProps {
  style?: IFormFieldStyle;
}

export const SimpleDateTimeFieldContainer = styled.div<SimpleDateTimeFieldContainerProps>`
  ${breakpoint("s", "down")} {
    ${({ style }) => {
      if (style?.mobile) {
        const { gridColumn } = style.mobile;

        return `
            ${gridColumn ? `grid-column: ${gridColumn} !important;` : ""}
          `;
      }
    }}
  }
`;

export const StyledInputDateMask = styled(InputMask)`
  ${InputFieldStyles}
`;

export const PrefixIcon = styled(Icon)`
  margin-left: ${space.m};
`;

export const DatePickerPrefixIcon = styled(Icon)`
  position: absolute;
  left: ${space.m};
`;

export const StyledInputTimeMask = styled(InputMask)`
  ${InputFieldStyles}
  padding-left: ${space.xs};
  padding-right: ${space.xs};
`;

export const StyledAmPmToggle = styled(Spacer)`
  margin-right: ${space.xs};
`;

export const StyledReactDatePicker = styled(ReactDatePicker)`
  ${InputFieldStyles}
  padding-left: calc(${space.xl} + ${space.xs});
`;

export const StyledPopperContainer = styled.div`
  .react-datepicker-popper {
    z-index: ${zIndex.modal};
  }
`;

export const StyledCalendarComponent = styled.div`
  border: 0 !important;
  box-shadow: ${boxShadow.m} !important;
  border-radius: ${borderRadius.s} !important;
  overflow: hidden !important;
  ${fontStyle.regular}

  .react-datepicker {
    &__header {
      background-color: ${colors.blackLight};
      border: 0;
      border-radius: ${borderRadius.s} ${borderRadius.s} 0 0;
    }

    &__current-month {
      color: ${colors.white};
    }

    &__day-name {
      color: ${colors.grey5};
    }

    &__month-container {
      border-radius: ${borderRadius.s};
    }

    &__month {
      border-radius: 0 0 ${borderRadius.s} ${borderRadius.s};
    }

    &__day {
      &:hover {
        background-color: ${rgba(colors.grey4, 0.25)};
        border-radius: 50%;
      }

      &--selected,
      &--keyboard-selected {
        background-color: ${colors.blackLight};
        border-radius: 50%;
        border: 0;
      }

      &--outside-month {
        background-color: transparent;
        color: ${rgba(colors.black, 0.25)};
      }
    }
  }
`;
